// extracted by mini-css-extract-plugin
module.exports = {"FormInput":"FormInput_FormInput__VEOIa","Label":"FormInput_Label__tU47P","Input":"FormInput_Input__wSzwH","Error":"FormInput_Error__QPPii"};